import { Link } from 'react-router-dom'
import { useConsent } from '@/hooks/useConsent'

export function ConsentBanner() {
  const { consent, grant, deny } = useConsent()
  if (consent !== null) return null

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Bandeau de consentement aux cookies"
      className="fixed bottom-0 left-0 right-0 z-[60] px-4 pt-2 pointer-events-none"
      // Au-dessus de la barre d'accueil de l'iPhone (viewport-fit=cover, lot 3).
      style={{ paddingBottom: "max(16px, calc(env(safe-area-inset-bottom) + 8px))" }}
    >
      <div
        className="mx-auto max-w-md bg-gray-900/95 border border-gray-800/60 rounded-2xl p-4 pointer-events-auto"
        style={{ backdropFilter: 'blur(12px)' }}
      >
        <p className="text-[13px] text-gray-200 leading-relaxed mb-3">
          On utilise PostHog pour des stats anonymes d'usage (pas de pub, pas de
          revente). Tu peux refuser, ça ne change rien à l'app.{' '}
          <Link
            to="/privacy"
            className="text-cyan-400 underline underline-offset-2 hover:text-cyan-300"
          >
            En savoir plus
          </Link>
        </p>
        <div className="flex gap-2">
          <button
            onClick={deny}
            className="flex-1 py-2.5 rounded-xl text-[13px] font-semibold text-gray-300 bg-gray-800/60 border border-gray-700/50 cursor-pointer hover:bg-gray-800 transition-colors"
          >
            Refuser
          </button>
          <button
            onClick={grant}
            className="flex-1 py-2.5 rounded-xl text-[13px] font-bold text-white cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #0369a1, #0891b2, #06b6d4)' }}
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  )
}
